import { useLocation, useParams } from 'react-router-dom';

export function useQueryObject() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const obj = {};
  params.forEach((v, k) => { obj[k] = v; });
  return obj;
}

export function useRouteParams() {
  return useParams();
}